<style scoped>
.mu-card {
  margin-bottom: 16px;
}
</style>

<template>
  <div>
    <mu-row gutter>
      <mu-col span="12" sm="12" md="12" lg="6" xl="4" v-for="action in exportActions">
        <mu-card>
          <mu-card-header :title="action.title">
            <mu-avatar color="primary" slot="avatar">
              <mu-icon :value="action.icon" />
            </mu-avatar>
          </mu-card-header>
          <mu-card-text>
            {{action.text}}
          </mu-card-text>
          <mu-card-actions>
            <mu-button flat @click="onAction(action.name)">
              {{$t('AnalyticsExport.export')}}
            </mu-button>
          </mu-card-actions>
        </mu-card>
      </mu-col>
    </mu-row>
    <mu-dialog :title="$t('AnalyticsExport.completion.display')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogCompletion">
      <mu-flex justify-content="center">
        <mu-checkbox :label="$t('AnalyticsExport.date.display')" v-model="modelDateTimeRange"></mu-checkbox>
      </mu-flex>
      <mu-flex justify-content="center" v-if="modelDateTimeRange">
        <mu-date-input v-model="modelDateTimeStart" :label="$t('AnalyticsExport.date.start')" type="dateTime"></mu-date-input>
        <mu-date-input v-model="modelDateTimeEnd" :label="$t('AnalyticsExport.date.end')" type="dateTime">></mu-date-input>
      </mu-flex>
      <mu-button slot="actions" flat color="primary" @click="flagDialogCompletion = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionCompletion"><mu-icon value="get_app"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('AnalyticsExport.videoAction.display')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogVideoAction">
      <mu-flex justify-content="center">
        <mu-checkbox :label="$t('AnalyticsExport.date.display')" v-model="modelDateTimeRange"></mu-checkbox>
      </mu-flex>
      <mu-flex justify-content="center" v-if="modelDateTimeRange">
        <mu-date-input v-model="modelDateTimeStart" :label="$t('AnalyticsExport.date.start')" type="dateTime"></mu-date-input>
        <mu-date-input v-model="modelDateTimeEnd" :label="$t('AnalyticsExport.date.end')" type="dateTime">></mu-date-input>
      </mu-flex>
      <mu-button slot="actions" flat color="primary" @click="flagDialogVideoAction = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionVideoAction"><mu-icon value="get_app"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import langEn from './lang/en.json'
import langZh from './lang/zh.json'

import axios from "axios";

export default {
  name: 'AnalyticsExport',
  props: {
    channel: {
      type: Object
    },
  },
  data() {
    return {
      // Flag
      flagDialogCompletion: false,
      flagDialogVideoAction: false,

      // Model
      modelDateTimeRange: false,
      modelDateTimeStart: "",
      modelDateTimeEnd: "",
    };
  },
  computed: {
    exportActions() {
      return [
        {
          icon: 'bar_chart',
          name: 'submission',
          title: this.$t('AnalyticsExport.submission.display'),
          text: this.$t('AnalyticsExport.submission.text')
        },
        {
          icon: 'check_circle_outline',
          name: 'completion',
          title: this.$t('AnalyticsExport.completion.display'),
          text: this.$t('AnalyticsExport.completion.text')
        },
        {
          icon: 'touch_app',
          name: 'videoAction',
          title: this.$t('AnalyticsExport.videoAction.display'),
          text: this.$t('AnalyticsExport.videoAction.text')
        }
      ]
    },
    modelDateTimeStartTimestamp() {
      var d = new Date(this.modelDateTimeStart);
      return d.getTime() / 1000;
    },
    modelDateTimeEndTimestamp() {
      var d = new Date(this.modelDateTimeEnd);
      return d.getTime() / 1000;
    },
  },
  watch: {

  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  mounted() {

  },
  methods: {
    onAction(action) {
      if(action === 'submission') {
        this.onClickSubmission();
      } else if(action === 'completion') {
        this.onClickCompletion();
      } else if(action === 'videoAction') {
        this.onClickVideoAction();
      }
    },
    // Event
    onClickSubmission() {
      axios({
        method: 'get',
        url: this.$store.getters.urlApi + "job/quiz/channel/" + this.channel._id,
        headers: {
          token: this.$store.state.auth.token
        },
      }).then(response => {
        var uid = response.data.data.uid;
        this.$store.commit('exportQueueAppend', {
          exportId: Math.random().toString(36).substring(7),
          uid: uid,
          text: this.channel.name,
          type: "quiz"
        });
      })
      .catch(err => {
      console.log(err.message)
      });
    },
    onClickCompletion() {
      this.flagDialogCompletion = true;
    },
    onActionCompletion() {
      this.flagDialogCompletion = false;
      var url = this.$store.getters.urlApi + "job/completion/channel/" + this.channel._id;
      if(this.modelDateTimeRange) {
        url += "?start=" + this.modelDateTimeStartTimestamp + "&end=" + this.modelDateTimeEndTimestamp;
      }
      axios({
        method: 'get',
        url: url,
        headers: {
          token: this.$store.state.auth.token
        },
      }).then(response => {
        var uid = response.data.data.uid;
        this.$store.commit('exportQueueAppend', {
          exportId: Math.random().toString(36).substring(7),
          uid: uid,
          text: this.channel.name,
          type: "completion"
        });
      })
      .catch(err => {
      console.log(err.message)
      });
    },
    onClickVideoAction() {
      this.flagDialogVideoAction = true;
    },
    onActionVideoAction() {
      this.flagDialogVideoAction = false;
      var url = this.$store.getters.urlApi + "job/videoAction/channel/" + this.channel._id;
      if(this.modelDateTimeRange) {
        url += "?start=" + this.modelDateTimeStartTimestamp + "&end=" + this.modelDateTimeEndTimestamp;
      }
      axios({
        method: 'get',
        url: url,
        headers: {
          token: this.$store.state.auth.token
        },
      }).then(response => {
        var uid = response.data.data.uid;
        this.$store.commit('exportQueueAppend', {
          exportId: Math.random().toString(36).substring(7),
          uid: uid,
          text: this.channel.name,
          type: "videoAction"
        });
      })
      .catch(err => {
        console.log(err.message)
      });
    },
  }
};
</script>
